import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahIndustries from "../components/truck-rental-fujairah/FujairahIndustries";
import FujairahAreas from "../components/truck-rental-fujairah/FujairahAreas";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import ChillerVanPricing from "../components/chiller-van/ChillerVanPricing";

import { chillerVanSharjahSections } from "../components/chiller-van-sharjah/chillerVanSharjahSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInSharjah = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cvs-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvs-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cvs-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvs-areas":
        return (
          <FujairahAreas
            key={index}
            title={section.title}
            description={section.description}
            areas={section.areas}
          />
        );

      case "cvs-industries":
        return (
          <FujairahIndustries
            key={index}
            title={section.title}
            description={section.description}
            industries={section.industries}
          />
        );

      case "cvs-pricing":
        return (
          <ChillerVanPricing
            key={index}
            title={section.title}
            description={section.description}
            tiers={section.tiers}
            tiersNote={section.tiersNote}
            routeTables={section.routeTables}
            zoneTables={section.zoneTables}
            note={section.note}
          />
        );

      case "cvs-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van for Rent in Sharjah — From AED 250/Day | Chiller Fleet</title>
        <meta name="description" content="Chiller van for rent in Sharjah from our local branch — 0°C to 8°C vans for Industrial Areas, SAIF Zone, Hamriyah and city centre delivery. Same-day dispatch. Book Now" />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-sharjah" />
        <meta property="og:title" content="Chiller Van for Rent in Sharjah — From AED 250/Day | Chiller Fleet" />
        <meta property="og:description" content="Chiller van for rent in Sharjah from our local branch — 0°C to 8°C vans for Industrial Areas, SAIF Zone, Hamriyah and city centre delivery. Same-day dispatch. Book Now" />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-sharjah" />
        <meta name="twitter:title" content="Chiller Van for Rent in Sharjah — From AED 250/Day | Chiller Fleet" />
        <meta name="twitter:description" content="Chiller van for rent in Sharjah from our local branch — 0°C to 8°C vans for Industrial Areas, SAIF Zone, Hamriyah and city centre delivery. Same-day dispatch. Book Now" />
      </Helmet>

      {chillerVanSharjahSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInSharjah;
